import { ChatState } from '@enuan/chat__utils';
import { configurationContext } from '../../contexts/configuration';
import { frameStateContext } from '../../contexts/frame/context';
import React, { JSX, useContext, useState } from 'react';
import { useSelector } from 'react-redux';
import { getUnreadMessagesCount } from '../../reduxStore';
import { styled } from '@mui/material/styles';
import classNames from 'classnames';

export const ChatNewMessagesFloaterBadge = styled(
	({ className, ...props }: Omit<JSX.IntrinsicElements['div'], 'children'>) => {
		const {
			isOpen: { isOpen },
		} = useContext(frameStateContext);
		const { state } = useContext(configurationContext);
		const newMessagesCount = useSelector(getUnreadMessagesCount);

		const isActive = state !== ChatState.OFF && !!state;

		const [badgeSize, setBadgeSize] = useState<number>(0);

		if (!newMessagesCount || isOpen || !isActive) {
			return null;
		}

		return (
			<div
				className={classNames('floater__badge', className)}
				{...props}
				ref={(el) => {
					setBadgeSize(el?.offsetHeight ?? 0);
				}}
			>
				<span style={{ fontSize: badgeSize * 0.6 }}>{newMessagesCount}</span>
			</div>
		);
	},
	{
		target: 'ChatNewMessagesFloaterBadge-root',
		label: 'ChatNewMessagesFloaterBadge',
	},
)({
	cursor: 'pointer',
	position: 'absolute',
	borderRadius: '50%',
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	backgroundColor: 'var(--toggler--primary)',
	color: 'var(--toggler_color)',

	'& span': {
		fontFamily: "'Ubuntu', sans-serif",
		fontWeight: 'bold',
		fontSize: '1.1em',
	},
	pointerEvents: 'all',

	width: '35%',

	top: 'calc(-35% * 0.5)',
	right: 'calc(-35% * 0.5)',
	'&:after': {
		content: "''",
		display: 'block',
		paddingBottom: '100%',
	},
	'&:has(.chat--detached .span)': {
		fontSize: 'xx-large',
	},
});
